import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { Grid, Button, withStyles, Typography, Drawer } from '@material-ui/core';

import { EmployeeDashboardMobileSidePanelStyles } from '../../../../styles/mobileStyles';
import { SearchMultiSelect, EmployeeProposableShifts } from '../../../components/core';
import { updateMobileOfferForm } from '../../../actions/mobileActions';
import { updateLoading, updateSnackbar, updateCheckedProposableShifts,
    addPrivateEmployeeProposableShiftsList, updateEmployeesToOfferList, addOrUpdateEmployeesToOfferList,
    resetAndAddEmployeesToOfferList, addOrUpdatevalidatedEmployeesToOfferList,
    resetEmployeesToOfferList, resetValidatedEmployeesToOfferList, updateLoadingPrivateEmployeesValidation,
    updateLoadingPrivateEmployeesNames, } from '../../../actions';
import { getEligiblePrivateEmployeeSchedule } from '../../Utils/dotNet';
import { isPartialOfShift } from '../../Utils/PartialShiftHelper';
import { RequestTypes, ValidationTypeName, TorCreationType, PrivateEmployeesRealTimeMessage } from '../../../../Enums';

class PrivateOffer extends Component {
    constructor(props) {
        super(props)
        this.currentEmployeeRequestData = null;
        this.state = {
            employeeList: undefined,
            privateEmployeeWarning: null,
            isPrivateEmployeeWarningModalOpen: false,
            isHelpDrawerOpen: false,
            privateEmployeeFilters: {// TODO: Better to put this in the store
                isExcludeNotTransferred: true,
                searchString: "",
                isShowWarnings: true,
            },
            requestId: null,
            isNextButtonDisabled: true,
        }
    }

    handleSnackbar = (type, message, openState) => {
        this.props.updateSnackbar({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    handleFilterChange = async (updatedFilters) => {
        const { employeesToOfferList, resetAndAddEmployeesToOfferList, signalRConnection } = this.props;
        const { privateEmployeeFilters } = this.state;
        const { isShowWarnings: currentIsShowWarnings, isExcludeNotTransferred: currentIsExcludeNotTransferred } = privateEmployeeFilters;
        let { isShowWarnings: nextIsShowWarnings, isExcludeNotTransferred: nextIsExcludeNotTransferred } = updatedFilters;
        let willCallFetchPrivateEmployees = true;
        
        if (currentIsShowWarnings != (nextIsShowWarnings ?? currentIsShowWarnings)) {
            willCallFetchPrivateEmployees = false;
        }
        nextIsExcludeNotTransferred = nextIsExcludeNotTransferred ?? currentIsExcludeNotTransferred
        if (currentIsExcludeNotTransferred != (nextIsExcludeNotTransferred)) {
            if (nextIsExcludeNotTransferred) {//filter already loaded list
                signalRConnection.send(PrivateEmployeesRealTimeMessage.RequestCancelTask, this.state.requestId.toString());
                const filtered = employeesToOfferList.validatedEmployees.filter(e => e.isPjAndJtsEmployee);
                resetAndAddEmployeesToOfferList(filtered);
                willCallFetchPrivateEmployees = false;
            }
        }

        this.setState(
            { privateEmployeeFilters: { ...privateEmployeeFilters, ...updatedFilters } },
            async () => {
                if (willCallFetchPrivateEmployees) {
                    await this.getEmployeesToOffer(false);
                }
            }
        );
    };
    
    componentDidMount() {
        const { signalRConnection, employeesToOfferList } = this.props;
        
        if (!employeesToOfferList.validatedEmployees.length) {
            this.getEmployeesToOffer();
        }

        if (signalRConnection) {
            signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeeNames, this.handleReceiveEmployeeNames);
            signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveValidations, this.handleReceiveValidations);
            signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingError, this.handleReceiveEmployeesError);
            signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingWithValidationError, this.handleReceiveValidationError);
        }
    }
    
    componentDidUpdate(prevProps) {
        if (!prevProps.signalRConnection && this.props.signalRConnection) {
            this.props.signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeeNames, this.handleReceiveEmployeeNames);
            this.props.signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveValidations, this.handleReceiveValidations);
            this.props.signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingError, this.handleReceiveEmployeesError);
            this.props.signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingWithValidationError, this.handleReceiveValidationError);
        }
    }

    componentWillUnmount() {
        const { signalRConnection } = this.props;
        if (signalRConnection) {
            signalRConnection.off(PrivateEmployeesRealTimeMessage.ReceiveEmployeeNames);
            signalRConnection.off(PrivateEmployeesRealTimeMessage.ReceiveValidations);
            signalRConnection.off(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingError);
            signalRConnection.off(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingWithValidationError);
        }
    }
        
    handleReceiveEmployeeNames = (employees) => {
        const { updateEmployeesToOfferList, addOrUpdateEmployeesToOfferList, employeesToOfferList, signalRConnection, updateLoadingPrivateEmployeesNames } = this.props;
        const data = this.currentEmployeeRequestData;

        addOrUpdateEmployeesToOfferList(employees.map(x => ({ ...x, isValidated: false, isValid: true })));
        updateLoadingPrivateEmployeesNames(false);

        if (data) {
            data.EmployeeIdsToValidate = employees.map(x => x.employeeId);

            const validatedEmployeesToAdd = employeesToOfferList.validatedEmployees.filter(x => x.isValidated && data.EmployeeIdsToValidate.includes(x.employeeId));
            updateEmployeesToOfferList(validatedEmployeesToAdd);
            const validatedEmployeeToAddIds = validatedEmployeesToAdd.map(x => x.employeeId);
            data.EmployeeIdsToValidate = data.EmployeeIdsToValidate.filter(x => !validatedEmployeeToAddIds.includes(x));

            if (data.EmployeeIdsToValidate?.length > 0) {
                // Wrap data with JWT token for secure SignalR communication
                const secureValidationData = {
                    Token: sessionStorage.getItem('authToken')?.replace('Bearer ', '') || '',
                    EmployeeSearch: data
                };

                signalRConnection.send(PrivateEmployeesRealTimeMessage.RequestEmployeeValidations, this.state.requestId.toString(), secureValidationData)
            } else {
                this.checkAndUpdateLoadingPrivateEmployeesValidation();
            }
        }
    }

    checkAndUpdateLoadingPrivateEmployeesValidation = () => {
        if(this.props.employeesToOfferList.employees.every(x => x.isValidated)){
            this.props.updateLoadingPrivateEmployeesValidation(false);
        }
    }

    handleReceiveValidations = (employees) => {
        this.props.updateEmployeesToOfferList(employees.map(x => ({ ...x, isValidated: true })));
        this.props.addOrUpdatevalidatedEmployeesToOfferList(employees.map(x => ({ ...x, isValidated: true })));
        this.checkAndUpdateLoadingPrivateEmployeesValidation();
    }

    getEmployeesToOffer = async () => {
        const { formData, updateLoadingPrivateEmployeesNames, signalRConnection, resetEmployeesToOfferList, updateLoadingPrivateEmployeesValidation } = this.props;
        const { privateEmployeeFilters, requestId } = this.state;
        const searchString = privateEmployeeFilters.searchString ?? "";
        const managerSettingGuid = formData.managerSetting.aggregateRootId;
        const listOfShifts = [formData.shifts[0]];
        updateLoadingPrivateEmployeesNames(true);
        updateLoadingPrivateEmployeesValidation(true);

        let isPartial = false;
        let partialStartDate, partialEndDate = null;
        if (isPartialOfShift(formData.partialDates, formData.shifts[0])) {
            isPartial = true;
            partialStartDate = formData.partialDates.startDate;
            partialEndDate = formData.partialDates.endDate;
        }

        if (requestId) {
            signalRConnection.send(PrivateEmployeesRealTimeMessage.RequestCancelTask, requestId.toString());
            resetEmployeesToOfferList();
        }

        const data = {
            ManagerSettingId: managerSettingGuid,
            Shifts: listOfShifts,
            SearchString: searchString.trim(),
            IsPartial: isPartial,
            PartialStartDate: partialStartDate,
            PartialEndDate: partialEndDate,
            IsShowPjAndJtsEmployeesOnly: privateEmployeeFilters.isExcludeNotTransferred,
        };
        try {
            this.currentEmployeeRequestData = data;
            const newRequestId = Math.random();
            this.setState({
                requestId: newRequestId,
            })

            // Wrap data with JWT token for secure SignalR communication
            const secureData = {
                Token: sessionStorage.getItem('authToken')?.replace('Bearer ', '') || '',
                EmployeeSearch: data
            };

            await signalRConnection.send(PrivateEmployeesRealTimeMessage.RequestEmployeeNames, newRequestId.toString(), secureData);
        } catch (error) {
            if (error.name === "AbortError") {
                console.log('AbortError 3: ' + error.message);
            } else {
                console.error("Error during fetch():", error);
                this.handleSnackbar('error', error.toString(), true);
            }
            updateLoadingPrivateEmployeesNames(false);
            updateLoadingPrivateEmployeesValidation(false);
        }
    }

    validateEmployeePriority = async (employeeId) => {
        const {
            options,
            updateEmployeesToOfferList,
            addOrUpdatevalidatedEmployeesToOfferList,
            formData,
            partialDates,
        } = this.props;
        const { privateEmployeeFilters } = this.state;

        const managerSettingGuid = formData.managerSetting.aggregateRootId;
        const listOfShifts = [formData.shifts[0]];
        let isPartial = false;
        let partialStartDate, partialEndDate = null;
        if (isPartialOfShift(partialDates, formData.shifts[0])) {
            isPartial = true;
            partialStartDate = partialDates.startDate;
            partialEndDate = partialDates.endDate;
        }

        const data = {
            ManagerSettingId: managerSettingGuid,
            Shifts: listOfShifts,
            SearchString: privateEmployeeFilters.searchString.trim(),
            IsPartial: isPartial,
            PartialStartDate: partialStartDate,
            PartialEndDate: partialEndDate,
            IsShowPjAndJtsEmployeesOnly: privateEmployeeFilters.isExcludeNotTransferred,
            EmployeeIdsToValidate: [employeeId]
        };

        try {
            const response = await fetch(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/dashboard/GetAvailableEmployeesForPrivateOfferingWithValidation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": sessionStorage.getItem('authToken') ?? '',
                    ...options,
                },
                body: JSON.stringify(data),
            });
            const reader = response.body?.getReader();
            const decoder = new TextDecoder();
            if (reader) {
                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;
                    const chunk = decoder.decode(value, { stream: true });
                    const lines = chunk.split("\n").filter(Boolean);
                    lines.forEach(line => {
                        try {
                            const item = JSON.parse(line);
                            updateEmployeesToOfferList(item.map(x => ({ ...x, isValidated: true })));
                            addOrUpdatevalidatedEmployeesToOfferList(item.map(x => ({ ...x, isValidated: true })));
                            this.checkAndUpdateLoadingPrivateEmployeesValidation();
                        } catch (err) {
                            console.log('Error parsing priority validation line:', err.message);
                            this.handleSnackbar('error', 'Failed to validate employees', true);
                            return;
                        }
                    });
                }
            }
        } catch (err) {
            console.log('Error validating employee in priority:', err);
            this.handleSnackbar('error', 'Failed to validate employees', true);
            return;
        }
    }

    fetchPrivateEmployeeProposableShifts = async (employeeId, isSkipValidation) => {
        const { formData, updateLoading, options, addPrivateEmployeeProposableShiftsList, proposableShiftsPerEmployee } = this.props

        const managerSettingGuid = formData.managerSetting.aggregateRootId;
        const managerSettingId = formData.managerSetting.id;
        const listOfShifts = [formData.shifts[0]];
        updateLoading(true)
        try {
            let partialStartDate, partialEndDate = null;
            if (isPartialOfShift(formData.partialDates, formData.shifts[0])) {
                partialStartDate = formData.partialDates.startDate;
                partialEndDate = formData.partialDates.endDate;
            }
            const employeesResponse = await getEligiblePrivateEmployeeSchedule(options, listOfShifts, managerSettingGuid, managerSettingId, employeeId, partialStartDate, partialEndDate, isSkipValidation);
            let updatedProposableShiftsPerEmployee = proposableShiftsPerEmployee;
            updatedProposableShiftsPerEmployee[employeeId] = employeesResponse.data;
            addPrivateEmployeeProposableShiftsList(updatedProposableShiftsPerEmployee);
            return employeesResponse.data;
        } catch (ex) {
            console.error(ex.response);
            return;
        } finally {
            updateLoading(false)
        }
    }

    isNextButtonDisabled = () => {
        const { formData, selectedProposableShiftsByOfferor, employeesToOfferList } = this.props
        const { employee, shifts } = selectedProposableShiftsByOfferor;
        if (formData.privateEmployeeSelected.length > 0) {
            const selectedEmployeeIds = formData.privateEmployeeSelected.map(x => x.employeeId);
            const selectedEmployees = employeesToOfferList.validatedEmployees.filter(x => selectedEmployeeIds.includes(x.employeeId));
            return selectedEmployees.length <= 0 || selectedEmployees.find(x => !x.isValidated || !x.isValid);
        }
        if (formData.managerSetting.type === RequestTypes.shiftSwap && formData.managerSetting.isAllowProposalWithOffer && employee.employeeId && shifts.length) {
            return false;
        }
        return true;
    }

    onClickInvalidEmployee = (employee, employeeName) => {
        const { t } = this.props;
        if (!employee.isValid) {
            this.setState({
                privateEmployeeWarning: `The employee ${employeeName} is not selectable due to a failing validation rule (${t(`employee.validationError.${ValidationTypeName[employee.failedValidationTypeId]}`)}).`,
                isPrivateEmployeeWarningModalOpen: true,
            });
        }
    }

    onClosePrivateEmployeeWarningModal = () => {
        this.setState({
            privateEmployeeWarning: null,
            isPrivateEmployeeWarningModalOpen: false,
        });
    }

    handleOpenDrawer = () => {
        this.setState({ isHelpDrawerOpen: true, isPrivateEmployeeWarningModalOpen: true });
    }

    handleCloseDrawer = () => {
        this.setState({ isHelpDrawerOpen: false, isPrivateEmployeeWarningModalOpen: false });
    }

    handleReceiveEmployeesError = (error) => {
        console.error('Error receiving employees:', error);
        if (error.message !== 'Operation was cancelled') {
            const isAuthError = error.message === 'Invalid authentication' ||
                               (typeof error === 'string' && (error.includes('Unauthorized -') || error.includes('Invalid or expired token') || error.includes('Authentication required')));
            this.handleSnackbar('error', `Failed to load employees.${isAuthError ? ' Please login again.' : ''}`, true);
        }
        this.props.updateLoadingPrivateEmployeesValidation(false);
        this.props.updateLoadingPrivateEmployeesNames(false);
    }

    handleReceiveValidationError = (error) => {
        console.error('Error validating employees:', error);
        if (error.message !== 'Operation was cancelled') {
            const isAuthError = error.message === 'Invalid authentication' ||
                               (typeof error === 'string' && (error.includes('Unauthorized -') || error.includes('Invalid or expired token') || error.includes('Authentication required')));
            this.handleSnackbar('error', `Failed to validate employees.${isAuthError ? ' Please login again.' : ''}`, true);
        }
        this.props.updateLoadingPrivateEmployeesValidation(false);
        this.props.updateLoadingPrivateEmployeesNames(false);
    }

    render() {
        const { formData, updateSidePanelView, handlePreviousView, classes, updateMobileOfferForm, t } = this.props
        const { employeeList, privateEmployeeWarning, isPrivateEmployeeWarningModalOpen, isHelpDrawerOpen, privateEmployeeFilters } = this.state
        const selectedEmployeeList = employeeList ? employeeList.employees : []
        const isAllowProposalWithOffer = formData.managerSetting.isAllowProposalWithOffer;
        const nextPage = formData.managerSetting.timeOffRequestCreationType === TorCreationType.Optional || formData.managerSetting.timeOffRequestCreationType === TorCreationType.Required ? 'TimeOffRequestCreation' : 'Summary';
        const isPartialShiftEnabled = formData.managerSetting.isPartialShiftEnabled;

        return (
            <div className={classes.privateOfferViewContainer}>
                <Typography variant={'h5'} className={classes.viewHeader}>Select coworkers: </Typography>

                {!isAllowProposalWithOffer && (
                        <SearchMultiSelect
                            handleSelection={(update) => updateMobileOfferForm({ privateEmployeeSelected: update })}
                            selection={formData.privateEmployeeSelected}
                            displayList={selectedEmployeeList}
                            getEmployeesToOffer={this.getEmployeesToOffer}
                            handleFilterChange={this.handleFilterChange}
                            isShowPreview
                            onClick={(employee) => {
                                if (!employee.isValidated) {
                                    this.validateEmployeePriority(employee.employeeId);
                                }
                                if (!employee.isValid) {
                                    this.onClickInvalidEmployee(employee, employee.label);
                                }
                            }}
                            isShowWarnings={privateEmployeeFilters.isShowWarnings}
                            isSizeSmall
                            height={630}
                        />
                       
                )}

                {isAllowProposalWithOffer && (
                    <EmployeeProposableShifts
                        getEmployeeProposableShifts={(employeeId, isSkipValidation) => this.fetchPrivateEmployeeProposableShifts(employeeId, isSkipValidation)}
                        offeredShiftsCount={formData.shifts.length}
                        getEmployeesToOffer={this.getEmployeesToOffer}
                        onClick={(employee) => this.onClickInvalidEmployee(employee, `${employee.firstName} ${employee.lastName}`)}
                        isPartialShiftEnabled={isPartialShiftEnabled}
                        handleOpenDrawer={this.handleOpenDrawer}
                        handleFilterChange={this.handleFilterChange}
                        isShowWarnings={privateEmployeeFilters.isShowWarnings}
                        isSizeSmall
                        height={630}
                    />
                )}

                <Grid container className={classes.bottomBar}>
                    <Grid item xs={6} style={{ padding: '5px' }}>
                        <Button fullWidth className={classes.secondaryButton} onClick={handlePreviousView}>Back</Button>
                    </Grid>
                    <Grid item xs={6} style={{ padding: '5px' }}>
                        <Button disabled={this.isNextButtonDisabled()} fullWidth className={classes.primaryButton} onClick={() => updateSidePanelView(nextPage)}>Next</Button>
                    </Grid>
                </Grid>

                <Drawer
                    anchor="bottom"
                    open={isPrivateEmployeeWarningModalOpen}
                    onClose={this.handleCloseDrawer}
                    classes={{ paper: classes.privateEmployeeWarningModal }}
                >
                    <Typography style={{ padding: '5px' }} variant={'h5'} className={classes.viewHeader}>
                        {isHelpDrawerOpen ? "Information" : "Rule violations"}
                    </Typography>
                    <Typography style={{ padding: '10px' }}>
                        {isHelpDrawerOpen 
                            ? "Check to see all the available shifts without the rules being pre-validated. Upon selecting a full or a partial shift, the validation will be done when submitting. This might result in having to submit more than once if the validations fail due to a schedule rule. This is recommended for partial shift requests." 
                            : privateEmployeeWarning} 
                    </Typography>
                </Drawer>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        formData: state.mobileOfferShiftForm,
        person: state.person,
        options: state.httpOptions,
        employeesToOfferList: state.employeesToOfferList,
        proposableShiftsPerEmployee: state.proposableShiftsPerEmployee,
        selectedProposableShiftsByOfferor: state.selectedProposableShiftsByOfferor,
        partialDates: state.partialDates,
        signalRConnection: state.signalRConnection,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateLoading: payload => dispatch(updateLoading(payload)),
        updateSnackbar: payload => dispatch(updateSnackbar(payload)),
        updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
        updateCheckedProposableShifts: payload => dispatch(updateCheckedProposableShifts(payload)),
        addPrivateEmployeeProposableShiftsList: payload => dispatch(addPrivateEmployeeProposableShiftsList(payload)),
        addOrUpdateEmployeesToOfferList: payload => dispatch(addOrUpdateEmployeesToOfferList(payload)),
        updateEmployeesToOfferList: payload => dispatch(updateEmployeesToOfferList(payload)),
        resetAndAddEmployeesToOfferList: payload => dispatch(resetAndAddEmployeesToOfferList(payload)),
        resetValidatedEmployeesToOfferList: payload => dispatch(resetValidatedEmployeesToOfferList(payload)),
        addOrUpdatevalidatedEmployeesToOfferList: payload => dispatch(addOrUpdatevalidatedEmployeesToOfferList(payload)),
        resetEmployeesToOfferList: () => dispatch(resetEmployeesToOfferList()),
        updateLoadingPrivateEmployeesValidation: payload => dispatch(updateLoadingPrivateEmployeesValidation(payload)),
        updateLoadingPrivateEmployeesNames: payload => dispatch(updateLoadingPrivateEmployeesNames(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('employmentBillboard')(withStyles(EmployeeDashboardMobileSidePanelStyles)(PrivateOffer)));
